var d = 9007199254740991, i = /^(?:0|[1-9]\d*)$/;
function n(r, s) {
  var t = typeof r;
  return s = s == null ? d : s, !!s && (t == "number" || t != "symbol" && i.test(r)) && r > -1 && r % 1 == 0 && r < s;
}
var o = n;
export {
  o as default
};
//# sourceMappingURL=_isIndex.js.map
